
// import { size } from 'lodash';
import React from'react';

// import SubmitButton  from '../Fields/SubmitButton';


function Popup(props){ 


    if(document.getElementById('chk_flood')!= null)
    {
    document.getElementById('chk_flood').checked= false;
  
    }
    let isChecked ;
    //let FaCross = require('react-icons/lib/fa/close');
    // let answers = JSON.parse(window.localStorage.getItem('answers'));
    // window.$.each(answers, function() {
    //     if (this.question === 'Buildings_Flood' || this.question === 'Contents_Flood') {
    //         if(this.answer === 'yes')
    //         {
    //             // isChecked = true;
    //            // document.getElementById('chk_flood').prop('checked', true);
    //         }
    //     }

    // });
    
    const mystyle = {
        width: '15%',
        margin: '-20px 48px 1px -29px'
    };


    const handleCheckboxChange = (event) => {
 
        
        
        if(localStorage.getItem("jpk")=="2"){
        let answers = JSON.parse(window.localStorage.getItem('answers'));
    
        answers = answers.filter(answer => 
            !(answer.question === 'Buildings_Flood' || answer.question === 'Contents_Flood')
        );
    
        if (event.target.checked) {
            // window.localStorage.setItem("Opt_in",true);
            // answers.push({ question: 'Opt_in', answer: true});

            answers.push({ question: 'Buildings_Flood', answer: 'yes' });
            answers.push({ question: 'Contents_Flood', answer: 'yes' });
            window.localStorage.setItem('answers', JSON.stringify(answers));
            event.target.checked=true;
        } else {
            
            answers = answers.filter(answer => 
                !(answer.question === 'Buildings_Flood' || answer.question === 'Contents_Flood')


            );

            // answers.push({ question: 'Opt_in', answer:false});
            
            window.localStorage.setItem('answers', JSON.stringify(answers));
            event.target.checked=false;
        }
    }
    
    if(localStorage.getItem("jpk")=="4"){
        
        let answers = JSON.parse(window.localStorage.getItem('answers'));
    
        answers = answers.filter(answer => 
            !(answer.question === 'Buildings_Flood' || answer.question === 'Contents_Flood')
        );
        if (event.target.checked) {
            // answers.push({ question: 'Opt_in', answer: true});

            answers.push({ question: 'Buildings_Flood', answer: 'yes' });
            answers.push({ question: 'Contents_Flood', answer: 'no' });
            window.localStorage.setItem('answers', JSON.stringify(answers));
            event.target.checked=true;
        } else {
            // window.localStorage.setItem("Opt_in",false);
            answers = answers.filter(answer => 
                !(answer.question === 'Buildings_Flood' || answer.question === 'Contents_Flood' )
            );
            // answers.push({ question: 'Opt_in', answer:false});
            window.localStorage.setItem('answers', JSON.stringify(answers));
            event.target.checked=false;
        }
    }
    
    
    if(localStorage.getItem("jpk")=="8"){
        let answers = JSON.parse(window.localStorage.getItem('answers'));
        answers = answers.filter(answer => 
            !(answer.question === 'Buildings_Flood' || answer.question === 'Contents_Flood')
        );
        if (event.target.checked) {
            // answers.push({ question: 'Opt_in', answer: true });
            answers.push({ question: 'Buildings_Flood', answer: 'no' });
            answers.push({ question: 'Contents_Flood', answer: 'yes' });
            window.localStorage.setItem('answers', JSON.stringify(answers));
            event.target.checked=true;
           
        } else {
          
            answers = answers.filter(answer => 
                !(answer.question === 'Buildings_Flood' || answer.question === 'Contents_Flood' )
            );
            // answers.push({ question: 'Opt_in', answer:false});
            window.localStorage.setItem('answers', JSON.stringify(answers));
            event.target.checked=false;
        }
    }
    
    
    
    };
    
return(props.trigger)?( 
   
    // <modal-container class='modal-active'  style={{height: '950px' }}>
    <modal-container class='modal-active'>
        {props.children} 
                        <modal>
                            <div className="modal-header" style={{color: '#ff6d1b'}}>
                            Flood Risk Area

                            {/* <a className="close-cross" >
                                <FaCross  onClick={closePopup}/>
                                </a> */}
                            </div>
                            <div className="modal-body">
                                <div>
                                    <p> 
                                        Our systems show that your property is in a higher risk area of flood { (window.localStorage.getItem('flood_subsidence_risk') === 'true')? "and subsidence" : null}. We are able to include cover for flood but this
                                        will increase the cost of your policy and an additional flood excess will apply. If you would like to include this cover 
                                        in your quote, please tick this box. The price will be available once cover options have been chosen. If you opt out of
                                        flood cover, you will not be covered for any loss or damage caused by flood, as specified in your policy wording and accompanying endorsement.                            
                                    </p>
                                   { 
                                    (window.localStorage.getItem('flood_subsidence_risk') === 'true')? 
                                    
                                   <p>
                                    Subsidence cover will be excluded from your policy. If you wish to discuss this or want to find out more
                                    about how this would impact your policy, please call our Insurance team on 0800 038 4574.
                                   </p> : null

                                   }
                                </div>
                                
                                    <input
                                        type="checkbox" name="flood_text" id= "chk_flood"
                                        onChange={handleCheckboxChange} checked = {isChecked}
                                        style={{display:"block",height:"20px",marginLeft:"-92px"}}
                                    
                                    />
                                     <label name="flood_text" style={{ marginLeft:"-100px"}}>if you would like to be covered for flood, please tick this box.</label>
                                  
                                <br/>
                                <br/>
                                <div className="modal-footer" >
                                    <button type='submit' onClick={acceptTerms} className="btn btn-success btn-split-content" style={mystyle}>
                                        Ok
                                    </button>
                                    
                                <br/>
                                </div>
                            </div>
                           
                        </modal>
        </modal-container>

):""; 

} 
// function closePopup()
// {
//    // window.localStorage.setItem('Cover_Flood', 'no');
//     <Popup trigger={false}> 
//     </Popup>
//     $(".modal-active").css("display", "none"); 
// }
function acceptTerms()
{
  
    let jpk = window.localStorage.getItem('jpk');
    let answers = JSON.parse(window.localStorage.getItem('answers'));
    answers = answers.filter(answer => 
        !(answer.question === 'Buildings_Flood' || answer.question === 'Contents_Flood' )
    );
    
    if(document.getElementById("chk_flood").checked==false){
        // answers.push({ question: 'Opt_in', answer:false});

    //    alert(jpk);
       
       if(jpk == 2){
        answers.push({ question: 'Buildings_Flood', answer:'no'});
        answers.push({ question: 'Contents_Flood', answer:'no'});

       }
       if(jpk == 4){
        answers.push({ question: 'Buildings_Flood', answer:'no'});
        answers.push({ question: 'Contents_Flood', answer:'no'});

       }
       if(jpk == 8){
        answers.push({ question: 'Buildings_Flood', answer:'no'});
        answers.push({ question: 'Contents_Flood', answer:'no'});

       }
        

    }
    if(document.getElementById("chk_flood").checked==true){
        // answers.push({ question: 'Opt_in', answer:true});
        // alert(jpk);

        if(jpk == 2){
            answers.push({ question: 'Buildings_Flood', answer:'yes'});
            answers.push({ question: 'Contents_Flood', answer:'yes'});
    
           }
           if(jpk == 4){
            answers.push({ question: 'Buildings_Flood', answer:'yes'});
            answers.push({ question: 'Contents_Flood', answer:'no'});
    
           }
           if(jpk == 8){
            answers.push({ question: 'Buildings_Flood', answer:'no'});
            answers.push({ question: 'Contents_Flood', answer:'yes'});
    
           }


    }
    window.localStorage.setItem('answers', JSON.stringify(answers));


    window.$.each(answers, function() {
       
        if (this.question === 'Buildings_Flood&Contents_Flood') {
            if(this.answer === 'yes')
            {   
                answers.push({question: 'Buildings_Flood', answer: 'yes'});
                answers.push({question: 'Contents_Flood', answer: 'yes'});
                
            
            }
        }
    });
   
    <Popup trigger={false}> 
    </Popup>
    $(".modal-active").css("display", "none"); 
}

export default Popup 

 


/** WEBPACK FOOTER **
 ** ./src/components/Modals/FloodPopup.js
 **/